import { apiServer } from "../config/appConfig";
import axios from "axios";

const defaultUrl = () => {
  return "/v1/nextoken/admin"
}

const setHeadersToken = (token) => {
  return {
    "Authorization" : token
  }
}

const accoutListService  = {

  getAllUserList(token, params) {
    return axios({
      method: "get",
      url: apiServer + defaultUrl() + "/status",
      headers: setHeadersToken(token),
      params : params,
      crossOrigin: true,
    })
  },

  unbannedAccount(token, params) {
    return axios({
      method: "put",
      url: apiServer + defaultUrl() + "/status",
      headers: setHeadersToken(token),
      params : params,
      crossOrigin: true,
    })
  }
  
}

export default accoutListService;